import basicScienceFacultyData from "./basicScienceFacultyData";
import civilFacultyData from "./civilFacultyData";
import cseAimlFacultyData from "./cseAimlFacultyData";
import cseFacultyData from "./cseFacultyData";
import eceFacultyData from "./eceFacultyData";
import eeeFacultyData from "./eeeFacultyData";
import mechanicalFacultyData from "./mechanicalFacultyData";

const facultyDataByDept = {
  bsh: basicScienceFacultyData,
  civil: civilFacultyData,
  "cse-aiml": cseAimlFacultyData,
  cse: cseFacultyData,
  ece: eceFacultyData,
  eee: eeeFacultyData,
  me: mechanicalFacultyData,
};

const withDept = (faculty, deptId, isHod = false) =>
  faculty
    ? {
        ...faculty,
        deptId,
        isHod,
        role: faculty.role || faculty.designation,
        designation: faculty.designation || faculty.role,
        qualifications: faculty.qualifications || faculty.qualification,
        qualification: faculty.qualification || faculty.qualifications,
        areas: faculty.areas || faculty.specializations || [],
        specializations: faculty.specializations || faculty.areas || [],
        courses: faculty.courses || [],
        recognition: faculty.recognition || [],
        bio: faculty.bio || faculty.description || "",
        description: faculty.description || faculty.bio || "",
        publications: faculty.publications ?? 0,
        projects: faculty.projects ?? 0,
      }
    : null;

export const facultyDirectory = Object.entries(facultyDataByDept).flatMap(
  ([deptId, data]) => [
    withDept(data.hod, deptId, true),
    ...(data.members || []).map((faculty) => withDept(faculty, deptId)),
  ].filter(Boolean)
);

export const facultyByDept = (deptId) =>
  facultyDirectory.filter((faculty) => faculty.deptId === deptId);

export const findFaculty = (id) =>
  facultyDirectory.find((faculty) => faculty.id === id);

export default facultyDirectory;
